import { createSelector } from "reselect";

export const publishRequestStatusesSelector = createSelector(
    state => state.services.publishRequestStatuses,
    state => state
);
